// @flow
import React from 'react';
import loadable from '@loadable/component';
import type { LoginCreds } from 'app/packages/pinterest-flow-types/authentication';
import type { SignupCredentialsAndLoggingData } from 'app/packages/pinterest-flow-types/registration';

type OwnProps = {|
  container?: string,
  handleFailureToShow?: () => void,
  handleSignupConfirmed?: (
    method: string,
    userData: {},
    credentials: SignupCredentialsAndLoggingData,
  ) => void,
  handleLoginError: () => void,
  handleLoginWithMfa: (creds: LoginCreds) => void,
  handleSignupError: () => void,
  handleShowLogin: () => void,
  showRegisterLoadingScreen?: () => void,
  shouldHide?: boolean,
|};

const GoogleOneTapPresenter = loadable(() =>
  import('app/common/react/components/growth/unauth/signup/GoogleOneTap/GoogleOneTapPresenter'),
);

export default function GoogleOneTapPresenterLoader({
  container,
  handleFailureToShow,
  handleSignupConfirmed,
  handleLoginError,
  handleLoginWithMfa,
  handleSignupError,
  handleShowLogin,
  showRegisterLoadingScreen,
  shouldHide,
}: OwnProps) {
  return (
    <GoogleOneTapPresenter
      container={container}
      handleFailureToShow={handleFailureToShow}
      handleSignupConfirmed={handleSignupConfirmed}
      handleLoginError={handleLoginError}
      handleLoginWithMfa={handleLoginWithMfa}
      handleSignupError={handleSignupError}
      handleShowLogin={handleShowLogin}
      showRegisterLoadingScreen={showRegisterLoadingScreen}
      shouldHide={shouldHide}
      fallback={<div />}
    />
  );
}
